
import { Component, mixins, Prop, Ref, Watch } from 'nuxt-property-decorator';
import TiptapEditorMixin from './TiptapEditorMixin';
import TiptapMenu from './TiptapMenu.vue';

@Component
export default class TiptapInlineEditor extends mixins(TiptapEditorMixin) {
  @Prop({ type: Boolean, default: false }) readonly borderless!: boolean;

  @Ref() menu?: TiptapMenu;
  @Ref() tiptapMenuWrapper?: HTMLDivElement;

  public isOpen = false;
  public mouseDownElement: HTMLElement | null = null;
  public isMouseDown = false;

  get hasSelection(): boolean {
    if (!this.editor) return false;
    const { selection } = this.editor.state;
    return selection && selection.from !== selection.to;
  }

  @Watch('hasSelection')
  onHasSelectionChange(value: boolean) {
    if (this.disabled) return;
    if (value) this.isOpen = value;
  }

  public onFocusHandler() {
    if (this.disabled) return;
    this.isOpen = true;
  }

  public onBlurHandler({ relatedTarget }: FocusEvent) {
    if (!(relatedTarget instanceof HTMLElement)) return;

    if (this.tiptapEditor?.contains(relatedTarget) || this.menu?.$el.contains(relatedTarget)) return;
    if (this.isMouseDown) return;

    this.isOpen = false;
  }

  public onMouseDownHandler({ target }: MouseEvent) {
    this.isMouseDown = true;

    if (!(target instanceof HTMLElement)) return;

    this.mouseDownElement = target;

    document.addEventListener('mouseup', this.onMouseUpHandler, { once: true });
  }

  public onMouseUpHandler({ target }: MouseEvent) {
    this.isMouseDown = false;

    if (!(target instanceof HTMLElement)) return;

    if (!this.mouseDownElement) return;
    if (this.tiptapEditor?.contains(this.mouseDownElement) || this.menu?.$el.contains(this.mouseDownElement)) return;
    if (this.tiptapEditor?.contains(target) || this.menu?.$el.contains(target)) return;

    this.isOpen = false;
  }

  public onShowHandler() {
    this.menu?.onResize();

    document.addEventListener('mousedown', this.onMouseDownHandler);

    this.emitFocus();
    this.isOpen = true;
  }

  public onHideHandler() {
    this.editor?.commands.setTextSelection(this.editor.state.selection.from);

    document.removeEventListener('mousedown', this.onMouseDownHandler);

    this.emitBlur();
    this.isOpen = false;
  }
}
